import React from "react";
import { useSelector } from "react-redux";
import { getCookie } from "../../util";

import {
  Pane,
  Button,
  Tooltip,
  HelpIcon,
  toaster,
  Popover,
  Paragraph,
  Spinner
} from 'evergreen-ui';

function SaveButtons(props) {
  const userid = useSelector((state) => state.user.value);

  const handleEnterEditMode = () => {
    if (props.setCancelled) { props.setCancelled(false) };

    if (props.locked) {
      toaster.warning(
        `Warning: ${props.lastEditor?.email || 'Another user'} recently edited this item. Your changes might conflict.`,
        { duration: 10 }
      );
    }

    props.setEditing(true);
  };

  const handleSave = async () => {
    let updateResult = await props.handleUpdate()
    console.log(updateResult)
  }

  const handleSaveAndClose = async () => {
    await props.handleUpdate();
    props.setEditing(false)
  }

  const handleDelete = async () => {
    let deleteResult = await props.handleDelete()
    console.log(deleteResult)
  }

  const handleCancel = async () => {
    props.resetForm()
    props.setEditing(false)
    if (props.setCancelled) { props.setCancelled(true) };
    props.refetch()
  }

  const canSave = props.canSave === undefined ? false : !props.canSave
  console.log('!!!!! SaveButtons props:', {
    canSave: props.canSave,
    computedCanSave: canSave,
    editing: props.editing,
    locked: props.locked,
    frozen: props.frozen
  });

  if (props.disabled) {
    return (
      <Pane display="flex" alignItems="center">
        <Tooltip content={"Temporarily disabled for site update."} ><HelpIcon color="muted" marginRight={16} /></Tooltip>
        <Button disabled={true} >Edit</Button>
      </Pane>
    )
  }
  else if (props.editing) {
    return (
      <Pane display="flex" alignItems="center">
        {(props.loading) && <Spinner size={24}/>}
        <Button marginRight={8} disabled={canSave} onClick={handleSaveAndClose}>Save</Button>
        <Button onClick={e => handleCancel()}>Cancel</Button>
      </Pane>
    )
  } else {
    return (
      <Pane display="flex" alignItems="center">
        <Button disabled={props.frozen} onClick={e => handleEnterEditMode()}>Edit</Button>
        <Popover
          content={({ close }) => (
            <Pane padding={16} >
              <Paragraph>Are you sure you want to delete this object?</Paragraph>
              <Paragraph>This action cannot be undone.</Paragraph>
              <Pane marginTop={16}>
                <Button marginRight={16} appearance="primary" intent="danger" onClick={e => handleDelete()} fontWeight="bold">
                  DELETE
                </Button>
                <Button onClick={close}> Cancel</Button>
              </Pane>
            </Pane>
          )}
        >
        <Button marginLeft={8} intent="danger" disabled={!props.canDelete} onClick={e => handleDelete()}>Delete</Button>
        </Popover>
        { !props.canDelete &&
        <Tooltip content={props.deleteMsg} ><HelpIcon color="muted" marginX={8} /></Tooltip>
        }

      </Pane>
    )
  }
}

export default SaveButtons;
